<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('extracurriculares.teachers.page_title')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">{{$t('extracurriculares.teachers.new_type')}}</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span v-show="!editingTeacher" class="headline">{{$t('extracurriculares.teachers.new_type')}}</span>
                        <span v-show="editingTeacher" class="headline">{{$t('extracurriculares.teachers.edit_type')}}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-autocomplete
                          v-show="!editingTeacher"
                          v-model="currentTeacherSearch"
                          :items="teachersResult"
                          :loading="isLoading"
                          :search-input.sync="searchTeacher"
                          color="primary"
                          hide-no-data
                          hide-selected
                          item-text="name"
                          item-value="name"
                          :placeholder="$t('extracurriculares.teachers.form.search')"
                          return-object
                        ></v-autocomplete>

                        <radio-input
                          v-show="!editingTeacher"
                          name="type"
                          :form="form"
                          :items="this.teachers_types"
                          :label="$t('extracurriculares.teachers.form.type')"
                          :v-errors="errors"
                          :value.sync="form.type"
                          v-validate="'required'"
                          read-only
                          :color="'primary'"
                        >
                        </radio-input>

                        <text-input
                          v-show="!editingTeacher"
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.company')"
                          :v-errors="errors"
                          :value.sync="form.company"
                          name="company"
                          v-validate="'required'"
                        ></text-input>

                        <text-input
                          v-show="!editingTeacher"
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.nit')"
                          :v-errors="errors"
                          :value.sync="form.nit"
                          name="nit"
                          v-validate="'required'"
                        ></text-input>

                        <text-input
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.name')"
                          :v-errors="errors"
                          :value.sync="form.name"
                          name="name"
                          v-validate="'required'"
                        ></text-input>

                        <number-input
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.phone')"
                          :v-errors="errors"
                          :value.sync="form.phone"
                          name="phone"
                        ></number-input>

                        <number-input
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.cel_phone')"
                          :v-errors="errors"
                          :value.sync="form.cel_phone"
                          name="cel_phone"
                        ></number-input>

                        <text-input
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.address')"
                          :v-errors="errors"
                          :value.sync="form.address"
                          name="address"
                        ></text-input>

                        <text-input
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.email')"
                          :v-errors="errors"
                          :value.sync="form.email"
                          name="email"
                          v-validate="'required|email'"
                        ></text-input>

                        <div class="editable_image" v-if="editingTeacher && image_to_edit">
                          <v-img
                            :src="image_to_edit"
                            width="50px"
                          >
                          </v-img>
                          <span>
                            <v-tooltip top>
                              <v-icon
                                small
                                class="mr-2"
                                @click="removeImage(form.id)"
                                slot="activator"
                              >
                                delete
                              </v-icon>
                              <span>{{$t('extracurriculares.clothes.delete')}}</span>
                            </v-tooltip>
                          </span>
                        </div>

                        <div class="upload">
                          <ul>
                            <li v-for="(file) in files" :key="file.id">
                              <span>{{file.name}}</span> -
                              <span>{{file.size}}</span>
                              &nbsp;&nbsp;&nbsp;
                              <span>
                                <v-tooltip top>
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click.prevent="$refs.upload.remove(file)"
                                    slot="activator"
                                  >
                                    delete
                                  </v-icon>
                                  <span>{{$t('extracurriculares.clothes.delete')}}</span>
                                </v-tooltip>
                              </span>
                            </li>
                          </ul>
                          <div class="example-btn">
                            <file-upload
                              class="mb-2 v-btn theme--dark primary"
                              extensions="gif,jpg,jpeg,png,webp"
                              accept="image/png,image/gif,image/jpeg,image/webp"
                              :multiple="true"
                              :size="1024 * 1024 * 10"
                              v-model="files"
                              @input-filter="inputFilter"
                              @input-file="inputFile"
                              ref="upload">
                              <i class="fa fa-plus"></i>
                              {{$t('extracurriculares.clothes.form.select_files')}}
                            </file-upload>
                          </div>
                        </div>

                        <text-area-input
                            :form="form"
                            :label="$t('extracurriculares.teachers.form.description')"
                            :v-errors="errors"
                            :value.sync="form.description"
                            name="description"
                        ></text-area-input>

                        <check-input
                          name="status"
                          :form="form"
                          :label="$t('extracurriculares.teachers.form.status')"
                          :value.sync="form.status"
                          :color="'primary'"
                          :v-errors="errors"
                        >
                        </check-input>

                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$t('extracurriculares.teachers.form.cancel')}}</v-btn>
                        <v-btn v-if="!editingTeacher" color="blue darken-1" flat @click="saveTeacher">{{$t('extracurriculares.teachers.form.save')}}</v-btn>
                        <v-btn v-else color="blue darken-1" flat @click="updateTeachers">{{$t('extracurriculares.teachers.form.update')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="teachers"
            :loading="loadingTable"
            class="elevation-1"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.company.name }}</td>
                <td class="text-xs-center">{{ props.item.company.nit }}</td>
                <td class="text-xs-center">
                  <v-img
                    v-if="props.item.image_url"
                    :src="props.item.image_url"
                    width="50px"
                  >
                  </v-img>
                </td>
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.phone }}</td>
                <td class="text-xs-center">{{ props.item.cel_phone }}</td>
                <td class="text-xs-center">{{ props.item.address }}</td>
                <td class="text-xs-center">{{ props.item.email }}</td>
                <td class="text-xs-center">{{ props.item.description }}</td>
                <td class="text-xs-center">
                  <v-checkbox
                    :key="props.item.id"
                    :name="`check_${props.item.id}`"
                    :input-value="props.item.status"
                    @change="handleTeachers(props.item.id, props.item.status)"
                    color="primary"
                    class="center"
                  ></v-checkbox>
                </td>
                <td>
                  <v-tooltip top>
                    <v-icon
                      medium
                      class="mr-2"
                      @click="editTeachers(props.item.id)"
                      slot="activator"
                    >
                      edit
                    </v-icon>
                    <span>{{$t('extracurriculares.teachers.edit')}}</span>
                  </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';
import FileUpload from 'vue-upload-component'
export default {
  name: 'enrollments-show-view',
  components: {
    FileUpload,
  },
  data() {
    return {
      headers: [
        { text: this.$t('extracurriculares.teachers.form.company'), align: 'center', value: 'type' },
        { text: this.$t('extracurriculares.teachers.form.nit'), align: 'center', value: 'name' },
        { text: '', align: 'center', value: 'image' },
        { text: this.$t('extracurriculares.teachers.form.name'), align: 'center', value: 'description' },
        { text: this.$t('extracurriculares.teachers.form.phone'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.teachers.form.cel_phone'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.teachers.form.address'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.teachers.form.email'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.teachers.form.description'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.teachers.form.status'), align: 'center', value: 'status' },
        { text: this.$t('extracurriculares.teachers.form.actions'), align: 'center', value: 'start_date', sortable: false }
      ],
      teachers: [],
      typesItems: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      form: new Form({
        company: '',
        nit: '',
        name: '',
        phone: '',
        cel_phone: '',
        address: '',
        email: '',
        description: '',
        status: true,
        type: '',
        company_name: '',
        company_phone: '',
        company_address: '',
        nit_vd: '',
        siesa_id: ''
      }),
      showSucessMessage: false,
      editingTeacher: false,
      userNameMaxLength: 60,
      entries: [],
      currentTeacherSearch: null,
      searchTeacher: null,
      teacherFound: {},
      teachers_types: [
        { value: "company", text: this.$t("extracurriculares.teachers.form.company") },
        { value: "teacher", text: this.$t("extracurriculares.teachers.form.teacher") }
      ],
      files: [],
      image_to_edit: null
    }
  },
  computed: {
    teachersResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    searchTeacher(val) {
      if (!val) return
      if (this.isLoading) return

      this.isLoading = true

      axios.get(`/api/extracurriculares/manage/search_teachers/${val}`)
        .then(res => {
          const { data } = res
          this.count = data.length;
          this.entries = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    currentTeacherSearch: function(newVal, oldval) {
      if (newVal) {
        axios.get(`/api/extracurriculares/manage/siesa/teacher/${newVal.id}`)
        .then(res => {
          const { data } = res
          this.count = data.length;
          this.teacherFound = data.teacher
          this.form.company =  data.teacher.type == 2
            ? data.teacher.full_name
            : `${data.teacher.name} ${data.teacher.lastname1} ${data.teacher.lastname2}`;
          this.form.nit = data.teacher.nit;
          if (data.teacher.type == 1) {
            this.form.name = `${data.teacher.name} ${data.teacher.lastname1} ${data.teacher.lastname2}`;
            this.form.phone = data.teacher.phone;
            this.form.cel_phone = data.teacher.cel_phone;
            this.form.address = data.teacher.address;
            this.form.email = data.teacher.email;
          } else {
            this.form.company_name = data.teacher.full_name;
            this.form.company_phone = data.teacher.phone;
            this.form.company_address = data.teacher.address;
            this.form.nit_vd = data.teacher.nit_vd;
          }
          this.form.siesa_id = data.teacher.rowid;
          this.form.company_id = '';
          this.form.type = data.teacher.type == 1 ? 'teacher' : 'company';
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
      }
    }
  },
  created() {
    this.getTeachers()
  },
  methods: {
    async getTeachers() {
      this.loadingTable = true;
      let { data } = await axios.get('/api/extracurriculares/manage/teachers')
      this.teachers = data;
      this.loadingTable = false;
    },
    close() {
      this.form = new Form({
        company: '',
        nit: '',
        name: '',
        phone: '',
        cel_phone: '',
        address: '',
        email: '',
        description: '',
        status: true,
        type: '',
        company_name: '',
        company_phone: '',
        company_address: '',
        nit_vd: '',
        siesa_id: ''
      })
      this.dialog = false
      this.editingTeacher = false
      this.entries = []
      this.currentTeacherSearch = null
      this.searchTeacher = null
      this.teacherFound = {}
    },
    async saveTeacher() {
      if (await this.formHasErrors()) return

      const result = await this.form.post('/api/extracurriculares/manage/teachers', this.form)

      if (result.status === 200) {
        let formData = new FormData();
        let fileData;
        this.files.forEach((file, index) => {
          fileData = this.$refs.upload.get(file.id);
          formData.append(`file_${index}`, fileData.file);
        });
        formData.append('teacher_id', result.data.teacher_id);
        const imageResult = await axios.post('/api/extracurriculares/manage/teachers/image', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (imageResult.status == 200) {
          this.getTeachers()
          this.currentTeacherSearch = null;
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: this.$t('extracurriculares.teachers.messages.saved_ok'),
            modal: false
          })
          this.files = []
        }

      }

      this.close()
    },
    editTeachers(id_teacher) {
      const TeachersToEdit = this.teachers.filter(type => type.id === id_teacher)[0];
      this.editingTeacher = true;
      this.dialog = true;
      this.form = new Form({
        company: TeachersToEdit.company.name,
        nit: TeachersToEdit.nit,
        name: TeachersToEdit.name,
        phone: TeachersToEdit.phone,
        cel_phone: TeachersToEdit.cel_phone,
        address: TeachersToEdit.address,
        email: TeachersToEdit.email,
        description: TeachersToEdit.description,
        status: TeachersToEdit.ustatuse,
        type: TeachersToEdit.type,
        company_name: TeachersToEdit.company_name,
        company_phone: TeachersToEdit.company_phone,
        company_address: TeachersToEdit.company_address,
        nit_vd: TeachersToEdit.nit_vd,
        siesa_id: TeachersToEdit.siesa_id,
        id: TeachersToEdit.id
      });

      this.image_to_edit = TeachersToEdit.image_url

    },
    deleteTeachers(id_teacher) {
      axios.delete(`/api/extracurriculares/manage/teachers/${id_teacher}`)
        .then(resp => {
          if (resp.status === 200) {
            this.teachers = this.teachers
              .filter(type => type.id !== id_teacher);
          }
        })
        .catch(error => console.log(error));
    },
    updateTeachers() {

      this.form.put('/api/extracurriculares/manage/teachers')
        .then(resp => {
          if (resp.status === 200) {
            if (this.files.length > 0) {
              let formData = new FormData();
              let fileData;
              this.files.forEach((file, index) => {
                fileData = this.$refs.upload.get(file.id);
                formData.append(`file_${index}`, fileData.file);
              });
              formData.append('teacher_id', resp.data.teacher_id);
              axios.post('/api/extracurriculares/manage/teachers/image', formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )
              .then(result => {
                if (result.status == 200) {
                  this.getTeachers()
                  this.close()
                  this.editingTeacher = false;
                  this.currentTeacherSearch = null;
                  this.files = []
                }
              })
              .catch(error => console.log(error))

            } else {
              this.getTeachers()
              this.close()
              this.editingTeacher = false;
              this.currentTeacherSearch = null;
              this.files = []
            }
          }
        })
        .catch(error => console.log(error));
    },
    handleTeachers(id_teacher, status) {
      axios.put('/api/extracurriculares/manage/teachers', { id: id_teacher, status: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.teachers = this.teachers.map(teacher => {
              if (teacher.id === id_teacher) {
                teacher.status = !status;
              }
              return teacher;
            })
          }
        })
    },
    onlyNumbers($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if(keyCode == 45) { //This is a code por - (minus sign)
            $event.preventDefault();
        }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('update', newFile)
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }

        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    removeImage(id) {

      axios.put('/api/extracurriculares/manage/teachers', { id: this.form.id, image_url: '' })
        .then(resp => {
          if (resp.status === 200) {
            this.image_to_edit = null
            this.teachers = this.teachers.map(teacher => {
              if (teacher.id === id_teacher) {
                teacher.image_url = null;
              }
              return teacher;
            })
          }
        })
        .catch(error => console.log(error))
    }
  }
}
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.editable_image {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/manage_columbus/teachers.vue